import getCustomizationVariables from "./getCustomizationVariables";

import {
	LOGIN,
	GET_AVATAR,
	OPEN_CLOSE_SIDEBAR,
	UPLOAD_FILE,
	RESET,
	UPDATE_KYC,
	SET_CUSTOMIZATION_ID,
	SET_MOBILE,
	SET_LANGUAGES,
} from './constants';

const initialState = {
	currentUser: {},
	userAvatar: {},
	ombraCSS: "ombra",
	sidebarCSS: "",
	fileToUpload: {},
	kycLevel: 0,
	customizationId: {},
	isMobile: false,
	isSidebarOpen: false,
};

const reducer = (state = initialState, action) => {
	const actionType = undefined === action ? null : action.type;
	if (actionType === LOGIN) {
		return { ...state, currentUser: { ...action.payload } };

	} else if (actionType === GET_AVATAR) {

		return Object.assign({}, state, {
			userAvatar: action.payload
		});
	} else if (actionType === OPEN_CLOSE_SIDEBAR) {
		return { ...state, isSidebarOpen: action.payload };
	} else if (actionType === UPLOAD_FILE) {

		return Object.assign({}, state, {
			fileToUpload: action.payload
		});
	} else if (actionType === UPDATE_KYC) {
		return Object.assign({}, state, {
			kycLevel: action.payload
		});
	} else if (actionType === RESET) {
		return initialState;
	} else if (actionType === SET_CUSTOMIZATION_ID) {
		const variables = getCustomizationVariables(action.payload);
		return {
			...state,
			customizationVariables: variables
		};
	} else if (actionType === SET_MOBILE) {
		return {
			...state,
			isMobile: action.payload
		};
	} else if (actionType === SET_LANGUAGES) {
		return { ...state, languages: action.payload };
	} else {
		return state;
	}
};

export default reducer;